import { EditorStandardFont } from 'src/models/userInterfaceSettings';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheEditorStandardFontQueryCallBack extends Callback<EditorStandardFont[]> {
	public constructor(private readonly applyEditorStandardFont: (font: EditorStandardFont | undefined) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: EditorStandardFont[]): void => {
		this.applyEditorStandardFont(successResponse.pop());
	};
}
